import React, { useEffect, useRef } from 'react';
import TiposEstrutura from '../components/TiposEstrutura';
import ContactForm from '../components/ContactForm';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
import './HomePage.css';
import './ContactSection.css';

const HERO_IMAGE_URL = '/index/inicio.png';
const TESTIMONIALS_IMAGE_URL = '/index/image2.avif';
const PRODUCTS_IMAGE_URL = '/index/image3.avif';
const PORTFOLIO_IMAGE_URL = '/index/image8.avif';

function HomePage() {
  const heroMsaRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    if (heroMsaRef.current) observer.observe(heroMsaRef.current);
    if (contactRef.current) observer.observe(contactRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div>
      {/* Seção apresentação MSA com imagem do Wagner */}
      <section className="hero-msa" ref={heroMsaRef}>
        <div className="hero-msa__wrapper">
          {/* Lado esquerdo - Conteúdo */}
          <div className="hero-msa__left">
            <h1 className="hero-msa__title">
              Transforme seu<br />
              estoque em um<br />
              <span className="hero-msa__title--blue">espaço organizado,</span><br />
              seguro e pronto<br />
              para crescer
            </h1>
            
            <p className="hero-msa__description">
              Soluções completas em porta paletes, desde o projeto 
              até a instalação, desenvolvidas para otimizar seu 
              espaço, aumentar a produtividade e organizar seu 
              estoque de forma prática, segura e eficiente.
            </p>
          </div>

          {/* Lado direito - Imagem do Wagner com benefícios integrados */}
          <div className="hero-msa__right">
            <img 
              src="/index/wagner2.png" 
              alt="Wagner - MSA Porta Paletes - Benefícios" 
              className="hero-msa__wagner"
            />
          </div>
        </div>
      </section>

      {/* Seção Solicite um Orçamento */}
      <section className="contact-section" ref={contactRef}>
        <div className="contact-section__wrapper">
          {/* Lado esquerdo - Formulário */}
          <div className="contact-section__left">
            <div className="contact-section__header">
              <h2 className="contact-section__title">Solicite um Orçamento</h2>
              <p className="contact-section__subtitle">
                Preencha o formulário e nossa equipe entrará em contato em até 24 horas.
              </p>
            </div>
            <ContactForm />
          </div>

          {/* Lado direito - Imagem Notebook */}
          <div className="contact-section__right">
            <img 
              src="/index/inicio3.png" 
              alt="Sistema MSA Porta Paletes - Tecnologia e Inovação" 
              className="contact-section__image"
            />
          </div>
        </div>
      </section>

      {/* Depoimentos de Clientes */}
      <Testimonials />
      
      <TiposEstrutura />
      
      <div className="hero">
        <img
          src={PORTFOLIO_IMAGE_URL}
          alt="MSA Porta Paletes - portfólio"
          className="hero__image"
        />
      </div>
      
      <Footer />
    </div>
  );
}

export default HomePage;
